/* eslint-disable @next/next/no-img-element */
import {  useMemo } from 'react'
const apiKey = process.env.mapApiKey

export default function GoogleMaps({contactNumber, company, contactAdress, lat, lng, src}) {

    // const googlemap = useRef(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const myLatLng = { lat: lat, lng: lng };

    // useEffect(() => {
    //     const loader = new Loader({
    //       apiKey: process.env.mapApiKey,
    //       version: 'weekly',
    //       libraries:["places"]
    //     });
    //     let map;
    //     loader.load().then(() => {
    //       map = new google.maps.Map(googlemap.current, {
    //         center: myLatLng,
    //         zoom: 10,
    //       });
    //       new google.maps.Marker({
    //         position: myLatLng,
    //         map,
    //         title: "DEF24",
    //       });
    //     }); 
    //   }, [myLatLng]);

      const map = useMemo(() => {
        if(!lat && !lng) {
          return <></>
        } 
        return <iframe
            className="google-map"
            style={{ border: "0", height:"24rem" }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/view?key=${apiKey}&zoom=9&center=${lat},${lng}`}>
        </iframe>
    }, [lat, lng])


      
    return (
        <div className="p-1">
            <h2 className="text-5 line-height-2 mb-1 text-color-primary pl-lg-1 d-flex align-items-center">
              <div style={{width: "1.8em", overflow:"hidden"}} className="mb-1 mr-2">
                <img width="100%" height="100%" src={src} alt="flag"/>
              </div>
              {company}
            </h2>
            {/* <div 
              id="map"
              style={{height:"24em"}} 
              className="google-map" 
              ref={googlemap}>
            </div> */}
            {map}
            <ul className="list list-icons mt-4 mb-4 d-flex flex-column justify-content-between" >
                <li className="text-primary w-75 line-height-3">
                  <i className="icon-pin icons pr-2"></i>
                  <span className="text-4-5"> {contactAdress} </span> 
                </li> 
                <li className="text-primary line-height-3">
                  <i className="icon-envelope icons pr-2" ></i>
                  <span className="text-4-5"> info@def24.com </span>
                </li>
                <li className="process-item line-height-3">
                  <i className="icon-call-end icons pr-2" ></i>
                  <a href={`tel:${contactNumber}`} className="process-item"> 
                    <span className="text-4-5"> {contactNumber} </span>
                  </a>
                </li>
            </ul>
        </div>
    )
}
